<template>
  <div>
    <ul class="pdf-buttons">
      <li
        v-if="files.length"
        class="action-buttons"
      >
        <ButtonIconTooltip
          :icon="'mdi-file-pdf-box'"
          :tooltip="fileName"
          @click.stop.prevent="onClickFile()"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonIconTooltip from '@/components/shared/widgets/ButtonIconTooltip';

export default {
    components: {
        ButtonIconTooltip,
    },
    props: {
        files: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
        ]),
        fileName() {
            let index = 0;
            if (this.files?.some(file => !!file.lang)) {
                index = this.files.findIndex(o => o.lang === this.userLang || o.lang === this.teamMainLang);
            }
            if (index > -1) {
                const file = this.files[index];
                if (file?.fileName && typeof file?.fileName === 'string') {
                    return file?.fileName;
                }
                return file?.file?.link?.fileName;
            }
            return undefined;
        },
    },
    methods: {
        async onClickFile() {
            let index = 0;
            if (this.files?.some(file => !!file.lang)) {
                index = this.files.findIndex(o => o.lang === this.userLang || o.lang === this.teamMainLang);
            }
            if (index > -1) {
                const file = this.files[index];
                // eslint-disable-next-line no-underscore-dangle
                const id = file?.id || file?.file?._id;
                const fileName = file?.fileName || file?.file?.link?.fileName;
                const { data } = await this.$rq.downloadFile(id);
                this.$utils.saveFileOnDisk(data, fileName);
                return false;
            }
            return undefined;
        },
    },
};
</script>
<style scoped>
  .table-cell-files{
      display: flex;
  }
</style>
